"use strict";

import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { GraphError } from './GraphError';
export const createGraphError = errors => {
  if (Array.isArray(errors)) {
    const errorMessage = _toConsumableArray(new Set(errors === null || errors === void 0 ? void 0 : errors.map(e => e.message))).join('\n');
    return new GraphError(errorMessage, errors);
  }
  return new GraphError(errors === null || errors === void 0 ? void 0 : errors.message, [errors]);
};